export const MAX_PRODUCTS_PICTURES = 3;
